module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-toolbar', {
    staticClass: "main-toolbar ql-project-header"
  }, [_c('div', {
    staticClass: "ql-project-header-column ql-project-header-column-left"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleLeftSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('h2', {
    staticClass: "md-title ql-project-header-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.projectTitle))]), _vm._v(" "), (_vm.currentVersion) ? _c('span', {
    staticClass: "project-version"
  }, [_vm._v(_vm._s(_vm.currentVersion.name))]) : _c('span', {
    staticClass: "project-version-live"
  }, [_vm._v("Live Edit")]), _vm._v(" "), (_vm.locked) ? _c('md-icon', [_vm._v("lock")]) : _vm._e(), _vm._v(" "), (_vm.locked) ? _c('md-tooltip', [_vm._v("This version is locked")]) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dark-mode-toggle"
  }, [_c('button', {
    staticClass: "ql-theme-toggle",
    attrs: {
      "type": "button",
      "aria-label": _vm.localShowMode ? 'Switch to light mode' : 'Switch to dark mode'
    },
    on: {
      "click": _vm.toggleShowMode
    }
  }, [_c('span', {
    staticClass: "ql-theme-toggle-ico"
  }, [_vm._v(_vm._s(_vm.localShowMode ? '☀' : '☾'))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.localShowMode ? 'Light' : 'Dark'))])])]), _vm._v(" "), (_vm.selectedThumbnailView === 'false') ? _c('project-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.listView),
      expression: "!listView"
    }],
    attrs: {
      "currentPage": _vm.currentPage,
      "selectedPageRenameIndices": _vm.selectedPageRenameIndices
    },
    on: {
      "pageUp": _vm.pageUp,
      "pageDown": _vm.pageDown,
      "setPage": _vm.setPage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedThumbnailView === 'true') ? _c('project-pagination', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.listView),
      expression: "!listView"
    }],
    attrs: {
      "currentPage": _vm.thumbnailPage,
      "step": _vm.thumbnailStep,
      "selectedPageRenameIndices": _vm.selectedPageRenameIndices
    },
    on: {
      "setPage": _vm.setThumbnailPage
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.selectedThumbnailView === 'false') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.listView),
      expression: "!listView"
    }],
    staticClass: "ql-project-header-column ql-project-header-column-right"
  }, [_c('md-button', {
    staticClass: "btn-toggle-worknote",
    class: {
      'btn-toggle-worknote--noteslist': _vm.notesListLinked
    },
    on: {
      "click": _vm.handleNotesAction
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.notesButtonIcon,
      "alt": _vm.tooltipText
    }
  }), _vm._v(" "), _c('md-tooltip', [_vm._v(_vm._s(_vm.tooltipText))])], 1), _vm._v(" "), _c('project-search')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ql-project-header-column ql-project-header-column-last"
  }, [_c('div', {
    staticClass: "connect-status",
    style: ({
      visibility: !_vm.connected ? 'visible' : 'hidden',
      display: !_vm.connected ? 'block' : 'none'
    })
  }, [_vm._v("Offline")]), _vm._v(" "), (_vm.selectedPageType === 'no' && !_vm.listView && _vm.selectedThumbnailView === 'false') ? _c('span', {
    staticClass: "dark-mode-toggle"
  }, [(_vm.mView) ? _c('md-switch', {
    staticClass: "margin-view",
    attrs: {
      "id": "showMargin",
      "name": "showMargin"
    },
    on: {
      "change": _vm.toggleMarginView
    },
    model: {
      value: (_vm.localShowMargin),
      callback: function($$v) {
        _vm.localShowMargin = $$v
      },
      expression: "localShowMargin"
    }
  }, [_vm._v("Margin View")]) : _c('md-switch', {
    staticClass: "margin-view",
    attrs: {
      "name": "showMargin"
    },
    on: {
      "change": _vm.toggleMarginView
    },
    model: {
      value: (_vm.localShowMargin),
      callback: function($$v) {
        _vm.localShowMargin = $$v
      },
      expression: "localShowMargin"
    }
  }, [_vm._v("Margin View")])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedThumbnailView === 'false') ? _c('div', {
    staticClass: "main-header-logo-wrapper",
    on: {
      "click": _vm.toggleListView
    }
  }, [(_vm.listView) ? [_c('div', [_c('img', {
    staticClass: "main-header-view-type",
    attrs: {
      "src": require('@/assets/img/Script_Icon.png'),
      "alt": "ListView"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-header-logo",
    attrs: {
      "src": require('../../assets/img/cuelist-list.svg'),
      "alt": "cuelisttext"
    }
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Switch to Script View")])], 1)] : [_c('div', [_c('img', {
    staticClass: "main-header-view-type",
    attrs: {
      "src": require('@/assets/img/List_Icon.png'),
      "alt": "ScriptView"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "main-header-logo",
    attrs: {
      "src": require('../../assets/img/cuelist-cue.svg'),
      "alt": "cuelisttext"
    }
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Switch to List View")])], 1)]], 2) : _c('div', {
    staticClass: "main-header-logo-wrapper",
    staticStyle: {
      "cursor": "auto"
    }
  }, [
    [_c('img', {
      staticClass: "main-header-logo",
      attrs: {
        "src": require('../../assets/img/cuelist-full.svg'),
        "alt": "cuelisttext"
      }
    })]
  ], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7278d540","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/header.vue
// module id = 1261
// module chunks = 21